export default "__VITE_ASSET__Cryy7rBp__"